import React from 'react';

import './HeaderRegular.scss';

export const HeaderRegular = ({ title }) => {
  return (
    <div styleName="header-regular">{title}</div>
  );
};
